import React from "react";
import { useCallback, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import useRoutesHelper from "../../../../hooks/useRoutesHelper";

import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../helpers/apiHelper";
import ModalWrapper from "../../../../components/Modal/ModalWrapper";
import CustomButton from "../../../../components/CustomButton";
import Text from "../../../../styleguide/Text";
import {
  fetchTemperatureAlerts,
  postSolveTemperatureAlert,
} from "../../../../redux/api/raports.api";
import { closeSolvingTemperatureAlertModal } from "../../../../redux/reducer/raports.reducer";
import TextInput from "../../../../components/misc/TextInput";

function SolveTemperatureAlertModal() {
  const dispatch = useAppDispatch();
  const { routeParams } = useRoutesHelper();

  const {
    raports: { isSolvingTemperatureAlertModalOpen, selectedTemperatureAlert },
  } = useAppSelector((state) => ({
    raports: state.raports,
  }));

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [observationsSolution, setObservationsSolution] = useState<
    string | number | null
  >(null);

  const handleOnSubmit = useCallback(
    async ({ handleClose }: any) => {
      if (!selectedTemperatureAlert) {
        return;
      }
      setIsLoading(true);

      const resultAction = await dispatch(
        postSolveTemperatureAlert({
          id_alerta: selectedTemperatureAlert.id_alerta,
          observatii: observationsSolution,
        }),
      );

      if (
        checkEndpointStatus(resultAction, postSolveTemperatureAlert) !==
        endpointStatus.pending
      ) {
        setIsLoading(false);
      }

      if (
        checkEndpointStatus(resultAction, postSolveTemperatureAlert) ===
        endpointStatus.fulfilled
      ) {
        const { page, rowsPerPage, status } = routeParams;

        dispatch(
          fetchTemperatureAlerts({
            page: page,
            perPage: rowsPerPage,
            status: status,
          }),
        );

        dispatch(closeSolvingTemperatureAlertModal());
        setObservationsSolution(null);

        handleClose && handleClose();
      }
    },
    [selectedTemperatureAlert, dispatch, observationsSolution, routeParams],
  );

  const isSubmitDisabled =
    !selectedTemperatureAlert?.id_alerta || !observationsSolution;

  const onClose = useCallback(() => {
    dispatch(closeSolvingTemperatureAlertModal());
    setObservationsSolution(null);
  }, [dispatch]);

  return (
    <>
      <ModalWrapper
        show={!!isSolvingTemperatureAlertModalOpen}
        title={`Rezolvare alerta pentru masina ${selectedTemperatureAlert?.plate}`}
        modalSize="sm"
        handleClose={onClose}>
        <div className="flex flex-col">
          <TextInput
            type="textarea"
            name="solving-alert"
            label="Adauga observatii"
            value={observationsSolution}
            onChange={(value) => setObservationsSolution(value)}
          />
        </div>

        <CustomButton
          type="submit"
          variant="contained"
          fullWidth
          className="mt-5 w-full"
          disabled={isSubmitDisabled}
          loading={isLoading}
          onClick={handleOnSubmit}>
          <Text variant="body1" isBold>
            Salveaza
          </Text>
        </CustomButton>
      </ModalWrapper>
    </>
  );
}

export default SolveTemperatureAlertModal;
